package eu.bontlab.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import eu.bontlab.sections.MainSection
import com.varabyte.kobweb.compose.foundation.layout.Box
import eu.bontlab.components.BackToTopButton
import eu.bontlab.components.OverflowMenu
import eu.bontlab.models.Mapdroid
import eu.bontlab.models.Diarydroid
import eu.bontlab.models.FantasyMaze3d
import eu.bontlab.models.Section
import eu.bontlab.models.Spinplayer
import eu.bontlab.models.Testimonial
// import eu.bontlab.sections.ContactSection
import eu.bontlab.sections.FooterSection
import eu.bontlab.sections.PortfolioSection


@Page
@Composable
fun HomePage() {
    var menuOpened by remember { mutableStateOf(false) }
    /*
    val worker = rememberWorker { EchoWorker { output -> console.log("Echoed: $output") } }
    LaunchedEffect(Unit) {
        worker.postInput("Hello, worker!")
    } */

    Box(modifier = Modifier
        .fillMaxSize()) {
        Column(
            modifier = Modifier
                .fillMaxSize(),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            MainSection(onMenuClicked = { menuOpened = true })
        //    ServiceSection()
            PortfolioSection<Mapdroid>(
                section = Section.PortfolioMapdroid,
                testimonial = Testimonial.First
            )

            PortfolioSection<Diarydroid>(
                section = Section.PortfolioDiarydroid,
                testimonial = Testimonial.Second
            )

            PortfolioSection<Spinplayer>(
                section = Section.PortfolioSpinplayer,
                testimonial = Testimonial.Third
            )

            PortfolioSection<FantasyMaze3d>(
                section = Section.PortfolioFantasyMaze3d,
                testimonial = Testimonial.Fourth
            )

       //     AboutSection()
        //    ContactSection()
            FooterSection()
        }

        BackToTopButton()
        if (menuOpened) {
            OverflowMenu(onMenuClosed = { menuOpened = false })
        }
    }
}
